// These country codes are the 2-digit DIN standard
export enum AvailableCountryCodes {
  UNITED_STATES = "US",
  UNITED_KINGDOM = "GB",
}
